import { useEffect, useState} from 'react';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { TwoSelections } from 'views/mutual/inputRadio';
import { CardLabel, QuestionCard } from 'views/mutual/questionCard';
import { IYesOrNoQuestion } from 'views/pages/compatibilityCheck/hooks';
import PDFViewer from 'views/mutual/pdfViewer';

type YesOrNoQuestionPageProps = {
  question: IYesOrNoQuestion;
  initialAnswer: boolean | null;
  onSubmit: (yesOrNo: boolean) => void;
  backQuestion: () => void;
};

export const YesOrNoQuestionPage = (props: YesOrNoQuestionPageProps) => {
  const [yesOrNo, setYesOrNo] = useState<boolean | null>(props.initialAnswer);
  const [yesOrNoError, setYesOrNoError] = useState<string>('');

  //ファイルが読まれたか
  const [readFlag, setReadFlag] = useState<boolean>(false);

  const validate = (yesOrNo: boolean | null) => {
    if (yesOrNo === null) {
      setYesOrNoError('選択してください');
      return false;
    } else {
      setYesOrNoError('');
      return true;
    }
  };

  // 連続で使われる場合があるので質問が変わった場合に前の値が残らないように初期化
  useEffect(() => {
    setYesOrNo(props.initialAnswer);
    setYesOrNoError('');
  }, [props.question, props.initialAnswer]);

  //戻った場合にもう一度読ませるなら、ここを使う
  // useEffect(() => {
  //   setReadFlag(false);
  // },[props.onSubmit])
  
  return (
    <>
      <div className="compatibilityCheck">
        <QuestionCard
          topChildren={<CardLabel letter={props.question.questionText} help={props.question.helpText} />}
          bottomChildren={
            <TwoSelections
              name="question"
              selected={yesOrNo}
              onChange={(yesOrNo: boolean) => {
                validate(yesOrNo);
                setYesOrNo(yesOrNo);
              }}
              error={yesOrNoError}
              disabledYes={props.question.kind === 'yesOrNoAndFile' ? !readFlag : false }
            />
          } 
        />
        {props.question.kind === 'yesOrNoAndFile' && props.question.file !== undefined && (
          <PDFViewer file={props.question.file} isBottom={() => setReadFlag(true)}/>
        )}
        
        <div className="compatibilityCheck_buttons">
          <Button
            type={ButtonType.Submit}
            label="次へ"
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            onClick={() => {
              if (validate(yesOrNo)) {
                props.onSubmit(yesOrNo || false);
              }
            }}
          />
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={props.backQuestion}
          />
        </div>
      </div>
    </>
  );
};
